import React from 'react';
import Algorithm from './Algorithm';
import Banner from './Banner';
import Example from './Example';
import { FairnessWrapper } from './styles';
import XCrash from './XCrash';

const Fairness: React.FC = () => {
  return (
    <FairnessWrapper>
      <Banner />
      <XCrash />
      <Algorithm />
      <Example />
    </FairnessWrapper>
  );
};

export default Fairness;
